import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";
import ComparePage from "@/components/CustomComponents/CompareSection";
const Loader = dynamic(() => import("@/components/loader"));

const LandingPage = ({ pageData = {}, compareMappingsData = {} }) => {
  const router = useRouter();
  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }
  return <ComparePage compareMappingsData={compareMappingsData} />;
};

export async function getServerSideProps({ params, preview }) {
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
    compareMappingsData,
  } = await getPageShellDataSafely({
    slug: `/compare`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: true,
  });

  const pageData = items?.[0]?.fields || null;

  return {
    props: {
      pageData,
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      compareMappingsData,
    },
  };
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
  compareMappingsData: PropTypes.object,
};

export default LandingPage;
